import DefaultModal from "components/Common/Modal/DefaultModal";
import ModalButton from "components/Common/Modal/ModalButton";
import React from "react";
import { useNavigate } from "react-router-dom";

const RejectedModal = ({ modalClose }: { modalClose: () => void }) => {
  const navigate = useNavigate();

  return (
    <DefaultModal
      title="회원가입 신청이 반려되었습니다"
      content="자세한 사항은 고객센터를 통해 문의바랍니다."
      handlModalClose={modalClose}
      state="error"
      button={
        <ModalButton
          buttonType="two"
          confirmButtonText="고객센터로 가기"
          handleConfirm={() => {
            navigate("/mypage/service-center");
            modalClose();
          }}
          handleCancel={modalClose}
        />
      }
    />
  );
};

export default RejectedModal;
